<template>
  <div class="club-points-history">
    <div class="club-points-history__form">
      <ui-input
        mask="interval"
        v-model="date"
        @mask-completed="submit"
        label="Период"
        placeholder="дд.мм.гггг - дд.мм.гггг"
        clearable
      />
    </div>

    <page-info
      v-if="!history.length"
      title="Операций с бонусами в выбранный период не производилось"
    />

    <vue-client-only v-else>
      <div>
        <club-points-history-table
          v-if="adaptive.isMobile"
          :history-records="history"
        />
        <club-points-history-table-desktop
          :history-records="history"
          v-else
        />
      </div>
    </vue-client-only>


    <order-popup redirect-to-orders />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ddmmyyyy } from '@/utils/date-to-string';
import ClubPointsHistoryTable from '@/components/account/club-table/club-points-history-table.vue';
import ClubPointsHistoryTableDesktop from '@/components/account/club-table/club-points-history-table-desktop.vue';
import OrderPopup from '@/components/account/order-popup.vue';
import PageInfo from '@/components/common/page-info.vue';
import VueClientOnly from 'vue-client-only';

const defaultFrom = new Date();
defaultFrom.setDate(defaultFrom.getDate() - 30);
const defaultTo = new Date();

export default {
  name: 'club-points-history',

  components: {
    ClubPointsHistoryTable,
    ClubPointsHistoryTableDesktop,
    OrderPopup,
    PageInfo,
    VueClientOnly,
  },

  inject: ['adaptive'],

  data() {
    return {
      date: `${ddmmyyyy(defaultFrom)} - ${ddmmyyyy(defaultTo)}`,
    };
  },

  computed: {
    history() {
      return this.$store.state.club.history;
    }
  },

  mounted() {
    this.loadHistory(this.parseDateRange(this.date));
  },

  methods: {
    ...mapActions('club', ['loadHistory']),

    parseDateRange(datesRangeString) {
      const {
        day1,
        month1,
        year1,
        day2,
        month2,
        year2,
      } = /(?<day1>\d\d)\.(?<month1>\d\d)\.(?<year1>\d\d\d\d) - (?<day2>\d\d)\.(?<month2>\d\d)\.(?<year2>\d\d\d\d)/
        .exec(datesRangeString)
        .groups;

      return  {
        dateFrom: `${year1}-${month1}-${day1}`,
        dateTo: `${year2}-${month2}-${day2}`,
      };
    },

    submit(value) {
      const datesRange = this.parseDateRange(value)

      this.loadHistory(datesRange);
    }
  }
}
</script>

<style lang="scss">
  .club-points-history {
    &__title {
      font-weight: 400;
    }

    &__form {
      background: $gray_bgr;
      border-radius: 4px 4px 0 0;
      border-bottom: 1px solid $gray_lu;
      padding: 0 12px 8px 12px;

      @include breakpoint("tablet") {
        border-radius: 4px;
        border-bottom: 0;
        padding: 20px 28px;
        margin-bottom: 30px;
      }

      .ui-input {
        min-height: 0;

        @include breakpoint("tablet") {
          display: flex;
          align-items: center;
        }

        label {
          @include breakpoint("tablet") {
            margin-right: 16px;
            margin-bottom: 0;
            font-size: 14px;
          }
        }

        .ui-input-input {
          @include breakpoint("tablet") {
            width: 240px;
          }
        }
      }
    }
  }
</style>
